import { useState, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { UseFAQ } from "./UseFAQ";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function AddFAQ(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { addFAQ } = UseFAQ();
  const [state, setState] = useState({
    productID: location.state.id,
    faQs: [],
  });
  const { isSmall } = useBreakpoints();

  let temp = location.state.FAQsRes;
  var lastOrderRow = Math.max.apply(
    Math,
    temp.map(function (o) {
      return o.rowNO;
    })
  );

  const [faqState, setFaqState] = useState({
    question: "",
    answer: "",
    rowNO: lastOrderRow != -Infinity ? lastOrderRow + 1 : 1,
  });

  useEffect(() => {
    if (faqState) {
      let temp = [];
      temp.push(faqState);
      setState({ ...state, faQs: temp });
    }
  }, [faqState]);

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/faq" },
          {
            name: "ویرایش سوالات متداول",
            url: "/faq/editfaq",
            targetID: location.state.id,
          },
          {
            name: "افزودن سوال",
            url: "/faq/AddFAQ",
            targetID: location.state.id,
            FAQsRes: location.state.FAQsRes,
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography sx={{ my: 1 }} variant="body1" color="secondary">
              سوال :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setFaqState({ ...faqState, question: data });
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography sx={{ my: 1 }} variant="body1" color="secondary">
              پاسخ :
            </Typography>
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setFaqState({ ...faqState, answer: data });
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                setProgress(true);
                addFAQ(state, () => {
                  navigate("/faq/editfaq", {
                    state: location.state,
                    replace: true,
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/faq/editfaq", {
                  state: location.state,
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default AddFAQ;
